import { Box, Stack, Typography } from '@mui/material'
import { usePendingApprovals, useDecideProposal } from '@/features/integrations'
import PendingApprovalRow from './PendingApprovalRow'

/**
 * Actions the assistant asked to take that are still waiting on the user.
 *
 * Renders nothing when the list is empty. An always-visible "no pending
 * approvals" panel trains people to ignore the space, which defeats the one
 * job this has: being noticed when something really is waiting.
 */
export default function PendingApprovalsPanel() {
  const { data: proposals = [] } = usePendingApprovals()
  const decide = useDecideProposal()

  if (!proposals.length) return null

  return (
    <Box
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 'var(--app-radius-md)',
        border: '1px solid var(--app-border-light)',
        bgcolor: 'var(--app-bg-panel)',
      }}
    >
      <Stack sx={{ gap: 0.25, mb: 1 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 650 }}>Waiting for your approval</Typography>
        <Typography sx={{ fontSize: 13, color: 'var(--app-text-secondary)' }}>
          Nothing here has run. Approving sends exactly what was proposed.
        </Typography>
      </Stack>
      {proposals.map((proposal) => (
        <PendingApprovalRow
          key={proposal.id}
          proposal={proposal}
          busy={decide.isPending}
          onDecide={(approved) => decide.mutate({ proposalId: proposal.id, approved })}
        />
      ))}
    </Box>
  )
}
